module.exports = __webpack_public_path__ + "img/Greenland.709c0641.svg";